import setStep from '../../../../api/deals/setStep';
import {
  DEAL_STATUS_CAR_DELIVERY,
  DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
  DEAL_STEPS,
} from '../../../../constants';
import alert from '../../../../helpers/alert';
import CarDelivery from '../CommonBankSteps/CarDelivery';
import CarRegistration from '../CommonBankSteps/CarRegistration';
import StepControlButtons from '../CommonBankSteps/StepControlButtons';

/**
 * Ð¥Ð²Ð¾ÑÑ ÑÐ´ÐµÐ»ÐºÐ¸ Ð¿Ð¾ Solva: ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð¢Ð¡ Ð¸ Ð²ÑÐ´Ð°ÑÐ°. ÐÐ°Ð»Ð¾Ð³Ð¾Ð²ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð² Ð±Ð°Ð½Ðº Ð½Ðµ
 * ÑÐ¾Ð±Ð¸ÑÐ°ÐµÑ â Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ Ð·Ð°Ð»Ð¾Ð³Ð°, Ð·Ð°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð¾ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐµ Ð² Ð·Ð°Ð»Ð¾Ð³ Ð¸ ÑÐ¿ÑÐ°Ð²ÐºÑ Ð¾Ð±
 * Ð¾ÑÑÑÑÑÑÐ²Ð¸Ð¸ Ð½Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¾Ð¹ Ð·Ð°Ð´Ð¾Ð»Ð¶ÐµÐ½Ð½Ð¾ÑÑÐ¸ Ñ Ð½ÐµÐ³Ð¾ Ð½Ðµ Ð¿ÑÐ¾ÑÑÑ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¾Ð±ÑÐ¸Ð¹ ÑÐºÑÐ°Ð½
 * Â«ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð´Ð»Ñ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð² Ð·Ð°Ð»Ð¾Ð³Â» Ð´Ð»Ñ Solva Ð¿ÑÐ¾Ð¿ÑÑÐºÐ°ÐµÑÑÑ (ÑÐ¼.
 * stepAfterNotarialDocuments).
 *
 * Ð¡Ð²Ð¾ÐµÐ³Ð¾ API ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸ Ñ Solva Ð½ÐµÑ, Ð² Ð±Ð°Ð½Ðº Ð¾ÑÑÑÐ´Ð° Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ ÑÑÐ¾Ð´Ð¸Ñ: Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¸Ð¼
 * Ð·Ð°Ð¿ÑÐ¾ÑÐ¾Ð¼ Ð±ÑÐ» CUSTOMER_ACCEPTED Ð½Ð° ÑÐ°Ð³Ðµ Ð½Ð¾ÑÐ°ÑÐ¸Ð°Ð»ÑÐ½ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð². ÐÐ°Ð»ÑÑÐµ Ð¼ÐµÐ½ÑÐµÐ¼
 * ÑÐ¾Ð»ÑÐºÐ¾ ÑÑÐ°ÑÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸.
 */
const SolvaFlow = ({ step, deal, update, loading, setLoading }) => {
  const onRegistrationSuccess = async () => {
    try {
      await setStep({ dealId: deal?.id, step: DEAL_STEPS.SOLVA.CAR_DELIVERY });
      update && update();
    } catch (e) {
      alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ ÑÐ¼ÐµÐ½Ðµ ÑÐ°Ð³Ð° ÑÐ´ÐµÐ»ÐºÐ¸');
      setLoading(false);
    }
  };

  if (step === DEAL_STEPS.SOLVA.AUTO_REGISTRATION) {
    return (
      <>
        <StepControlButtons
          dealId={deal?.id}
          prevStep={DEAL_STEPS.NOTARIAL_DOCUMENTS}
          nextStep={DEAL_STEPS.SOLVA.CAR_DELIVERY}
          update={update}
          setLoading={setLoading}
        />
        <CarRegistration
          deal={deal}
          loading={loading}
          setLoading={setLoading}
          onSuccess={onRegistrationSuccess}
          statusOption={[
            {
              value: DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
              label: 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð¢Ð¡ Ð½Ð° ÑÑÐµÑ',
            },
            {
              value: DEAL_STATUS_CAR_DELIVERY,
              label: 'ÐÐ°ÑÐ¸Ð½Ð° Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð° Ð½Ð° ÑÑÐµÑ',
            },
          ]}
        />
      </>
    );
  }

  if (step === DEAL_STEPS.SOLVA.CAR_DELIVERY) {
    return (
      <>
        <StepControlButtons
          dealId={deal?.id}
          prevStep={DEAL_STEPS.SOLVA.AUTO_REGISTRATION}
          nextStep={DEAL_STEPS.FINISH}
          update={update}
          setLoading={setLoading}
        />
        <CarDelivery deal={deal} loading={loading} setLoading={setLoading} onSuccess={update} />
      </>
    );
  }

  return null;
};

export default SolvaFlow;
